import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { io } from "socket.io-client";
import { toast, ToastContainer } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../services/BaseURL";
const AppDataContext = createContext();
const socket = io("https://ronaqbanquets.onrender.com", { transports: ["websocket"] });


const playNotificationSound = () => {
  const audio = new Audio("/notification.wav");
  audio.play().catch(() => {});
};

export const AppDataProvider = ({ children }) => {
  const [newBookingsCount, setNewBookingsCount] = useState(0);
  const [newContactsCount, setNewContactsCount] = useState(0);
  const navigate = useNavigate();


  const handleContactClick = useCallback(() => {
    navigate("/admin/dashboard/contacts");
  }, [navigate]);

  const handleBookingClick = useCallback(() => {
    navigate("/admin/dashboard/bookings");
  }, [navigate]);

  useEffect(() => {
    const contactToastId = "contact-notification";
    const bookingToastId = "booking-notification";

    socket.on("contact:new", () => {
      playNotificationSound();
      setNewContactsCount((prev) => prev + 1);

    
      if (!toast.isActive(contactToastId)) {
        toast.info("📝 New Contact Received", {
          toastId: contactToastId,
          position: "bottom-right",
          autoClose: 3000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          onClick: handleContactClick,
        });
      }
    });

    socket.on("booking:new", () => {
      playNotificationSound();
      setNewBookingsCount((prev) => prev + 1);

      
      if (!toast.isActive(bookingToastId)) {
        toast.info("📚 New Booking Received", {
          toastId: bookingToastId,
          position: "bottom-right",
          autoClose: 3000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          onClick: handleBookingClick,
        });
      }
    });

    return () => {
      socket.off("contact:new");
      socket.off("booking:new");
    };
  }, [handleContactClick, handleBookingClick]);

  const createContact = async (data) => {
    const res = await axios.post(`${API_BASE_URL}/api/contact`, data);
    return res.data;
  };

  const createBooking = async (data) => {
    const res = await axios.post(`${API_BASE_URL}/api/book`, data);
    return res.data;
  };

  const fetchCounts = async () => {
    try {
      const bookingRes = await axios.get(`${API_BASE_URL}/book/stats/new-counts`);
      const contactRes = await axios.get(`${API_BASE_URL}/contact/new-counts`);

      setNewBookingsCount(bookingRes.data.count || 0);
      setNewContactsCount(contactRes.data.newContactsCount || 0);
    } catch (error) {
      console.error("Error fetching counts:", error);
    }
  };

  useEffect(() => {
    fetchCounts();
  }, []);

  return (
    <AppDataContext.Provider
      value={{
        createContact,
        createBooking,
        newBookingsCount,
        newContactsCount,
        fetchCounts,
      }}
    >
      {children}
      
      <ToastContainer 
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </AppDataContext.Provider>
  );
};

export const useAppData = () => useContext(AppDataContext);